import type { AddressCoordinates, UserAddress, UserAddressFieldType } from '../../../../entities'
import { BUILDING_DETAILS_FIELD_OPTIONS } from '../../../constants'
import type { AddressListItem } from './types'

export const BROWSER_LOCATION_ERROR_MESSAGE = 'User did not share location'
export const CURRENT_LOCATION_THRESHOLD = 0.001

export const isAddressInCurrentLocation = ({
  address,
  browserLocation,
}: {
  address: UserAddress
  browserLocation: AddressCoordinates | null
}): boolean => {
  if (!browserLocation) {
    return false
  }
  return (
    Math.abs(browserLocation?.latitude - address.latitude) < CURRENT_LOCATION_THRESHOLD &&
    Math.abs(browserLocation?.longitude - address.longitude) < CURRENT_LOCATION_THRESHOLD
  )
}

export function moveAddressToTop(
  addressList: AddressListItem[],
  addressInCurrentLocation: AddressListItem
) {
  addressList.splice(addressList.indexOf(addressInCurrentLocation), 1)
  addressList.unshift(addressInCurrentLocation)
  return addressList
}

export const getAddressInCurrentLocation = (addressList: AddressListItem[]) =>
  addressList.find((address) => address.isCurrentLocation)

export const getNormalizedAddressList = (
  userAddressList: UserAddress[],
  browserCurrentLocation: AddressCoordinates | null
) => {
  if (!userAddressList) {
    return []
  }
  const addressList = userAddressList.map((item) => ({
    ...item,
    isCurrentLocation: isAddressInCurrentLocation({
      address: item,
      browserLocation: browserCurrentLocation,
    }),
  }))

  const addressInCurrentLocation = getAddressInCurrentLocation(addressList)
  if (addressInCurrentLocation) {
    moveAddressToTop(addressList, addressInCurrentLocation)
  }
  return addressList
}

export const checkHasMissingAddressDetails = (addressItem: AddressListItem): boolean => {
  const requiredFields = BUILDING_DETAILS_FIELD_OPTIONS[addressItem.kind]
    .filter((field) => field.required)
    .map((field) => field.type)

  if (requiredFields.length === 0) {
    return false
  }
  const addressFields: UserAddressFieldType[] = addressItem.fields.map((field) => field.type)

  return requiredFields.some((field) => !addressFields.includes(field))
}
